var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.969 40.074h-29.9V13.623h-2.575V41.36c0 .711.576 1.287 1.287 1.287H43.97v-2.574z",
    fill: "#1B264F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.68 37.287V30.3h-6.763v6.988h6.763z",
    fill: "#1B264F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.445 37.287v-13.24h-6.762v13.24h6.762z",
    fill: "#324489"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.203 37.287V14.874h-6.762v22.413h6.762z",
    fill: "#506BCA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.969 37.287V17.794h-6.763v19.493h6.763z",
    fill: "#9BAEF1"
  })));
}
export default __webpack_public_path__ + "media/homeProperty/stock-0d404050.svg";
export { SvgStock as ReactComponent };